export enum UrlActionTrigger {
  IntercomOpen = 'intercom_open',
  IntercomMessage = 'intercom_message',
  PlanPickerOpen = 'plan_picker_open',
  CreateJobOpen = 'create_job_open',
}
